import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { parseJson } from '@medicusunion/front-utils';

import { IPatientState } from './types';
import { instance } from 'utils/api';

export const fetchPatientHealthData = createAsyncThunk(
  'patients/fetchPatientHealthData',
  async (patientId: string) => {
    const response = await instance.get(`health/patient/${patientId}`);

    return {
      patientId,
      data: parseJson(response.data.data?.patient_health) || null
    };
  }
);

const initialState: IPatientState = {
  healthApp: {
    data: {},
    loading: {}
  }
};

const patientsSlice = createSlice({
  name: 'patient',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchPatientHealthData.pending, (state, action) => {
      console.log('action', action);
      const patientId = action.meta.arg;
      state.healthApp.loading[patientId] = true;
    });
    builder.addCase(fetchPatientHealthData.fulfilled, (state, action) => {
      console.log('action.payload', action.payload);
      const { patientId, data } = action.payload;

      state.healthApp.data[patientId] = data;
      state.healthApp.loading[patientId] = false;
    });
    builder.addCase(fetchPatientHealthData.rejected, (state, action) => {
      console.log('action', action);
      const patientId = action.meta.arg;
      state.healthApp.loading[patientId] = false;
    });
  }
});

export default patientsSlice.reducer;
